module.exports = __webpack_public_path__ + "img/new-small.202d6363.jpg";